export const getManyProductsByManySkus = (skus: string[]) => {
  if (!skus || !(skus instanceof Array)) {
    throw new Error(`Must provide handles to queryGetManyProductsBySKU; provided: ${typeof skus === 'object' ? JSON.stringify(skus) : skus} `)
  }

  const variables = { query: skus.join(' OR '), first: 100 }
  const query = `
    query searchProducts($query: String!, $first: Int) {
      search(query:$query, first: $first) {
        nodes {
          ... on Product {
            id
            title
            handle
            productBiline: metafield(namespace: "custom", key: "product_bi_line") {
              value
            }
            variants (first: 100) {
              nodes {
                id
                availableForSale
                sku
                price {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  `

  return { query, variables }
}
